import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import firebase from "./../../../../firebase";
import * as nftActions from "../../../../store/actions/nftActions";
import { useSelector, useDispatch } from "react-redux";
import NFTCards from "../../../../components/nftCards/NFTCards";

// Stylesheet
import "./Welcome.css";

// Assets
import arrow from "../../../../assets/createNFT.png";
import welcome from "../../../../assets/welcome.png";
import jonathan from "../../../../assets/jonathan.png";

function Welcome() {
  const [nft, setNft] = React.useState({});
  const [user, setUser] = React.useState({});

  useEffect(async () => {
    await firebase
      .firestore()
      .collection("NFTDataModel")
      .limit(1)
      .orderBy("score", "desc")
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          return;
        } else {
          querySnapshot.forEach((doc) => {
            let document = doc.data();
            document.docID = doc.id;
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  let userdocument = docuser.data();
                  document.userImageURL = userdocument.imageURL;
                  document.username = userdocument.username;
                  setNft(document);
                });
              });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <section className="half-sections">
      <div className="left">
        <div className="line-heading">
          <div className="line"></div>
          <h3 className="yellow">WELCOME TO LOOPGEM</h3>
        </div>
        <h1 className="main-heading">
        Create, <span className="yellow">Promote</span> and Sell NFTs
        </h1>
        <p className="desc">
          On a mission to help every creator in the world promote their NFT
        </p>
        <Link to="/createnft" className="create-nft">
          <h3 className="yellow">Create & Promote</h3>
          <img src={arrow} alt="Create NFT" />
        </Link>
      </div>

      <div className="right">
        <div className="reflection-effect">
          <NFTCards nfts={[nft]} length="1" />
        </div>
      </div>
    </section>
  );
}

export default Welcome;
